import { render, staticRenderFns } from "./WatchersMenu.vue?vue&type=template&id=18fd0c28&scoped=true"
import script from "./WatchersMenu.vue?vue&type=script&lang=js"
export * from "./WatchersMenu.vue?vue&type=script&lang=js"
import style0 from "./WatchersMenu.vue?vue&type=style&index=0&id=18fd0c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fd0c28",
  null
  
)

export default component.exports